import defaultSiteContent from './defaultSiteContent.json';

export const SITE_CONTENT_STORAGE_KEY = 'firat-celik-kapi-site-content-v1';

const isPlainObject = (value) =>
  value && typeof value === 'object' && !Array.isArray(value);

export const deepClone = (value) => JSON.parse(JSON.stringify(value));

export const deepMerge = (base, override) => {
  if (Array.isArray(base)) {
    return Array.isArray(override) ? [...override] : [...base];
  }

  if (!isPlainObject(base)) {
    return override === undefined ? base : override;
  }

  const result = { ...base };
  Object.keys(override || {}).forEach((key) => {
    const baseValue = base[key];
    const overrideValue = override[key];

    if (Array.isArray(baseValue)) {
      result[key] = Array.isArray(overrideValue) ? [...overrideValue] : [...baseValue];
      return;
    }

    if (isPlainObject(baseValue)) {
      result[key] = deepMerge(baseValue, isPlainObject(overrideValue) ? overrideValue : {});
      return;
    }

    result[key] = overrideValue === undefined ? baseValue : overrideValue;
  });

  return result;
};

export const getDefaultSiteContent = () => deepClone(defaultSiteContent);

export const loadSiteContent = () => {
  if (typeof window === 'undefined') {
    return getDefaultSiteContent();
  }

  try {
    const raw = window.localStorage.getItem(SITE_CONTENT_STORAGE_KEY);
    if (!raw) {
      return getDefaultSiteContent();
    }

    const parsed = JSON.parse(raw);
    return deepMerge(getDefaultSiteContent(), parsed);
  } catch (error) {
    return getDefaultSiteContent();
  }
};

export const saveSiteContent = (content) => {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.setItem(SITE_CONTENT_STORAGE_KEY, JSON.stringify(content));
};

export const resetSiteContentStorage = () => {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.removeItem(SITE_CONTENT_STORAGE_KEY);
};

export const getByPath = (obj, path, fallback = '') => {
  if (!path) {
    return obj;
  }

  const value = path.split('.').reduce((acc, key) => {
    if (acc === null || acc === undefined) {
      return undefined;
    }
    return acc[key];
  }, obj);

  return value === undefined ? fallback : value;
};

export const setByPath = (obj, path, value) => {
  const next = deepClone(obj);
  const keys = path.split('.');
  let cursor = next;

  for (let i = 0; i < keys.length - 1; i += 1) {
    const key = keys[i];
    if (!isPlainObject(cursor[key]) && !Array.isArray(cursor[key])) {
      cursor[key] = {};
    }
    cursor = cursor[key];
  }

  cursor[keys[keys.length - 1]] = value;
  return next;
};

export const getActiveLocale = (content) =>
  getByPath(content, 'settings.activeLanguage', 'tr');

export const getTranslations = (content, locale) => {
  const activeLocale = locale || getActiveLocale(content);
  const fallback = getByPath(content, 'translations.tr', {});
  return getByPath(content, `translations.${activeLocale}`, fallback) || fallback;
};

export const resolveMediaSrc = (value, fallbackValue) => {
  if (typeof value === 'string' && value.trim()) {
    return value.trim();
  }

  return fallbackValue;
};
